import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "trigger"]

  connect() { this.updateAccessibility() }

  toggle(event) {
    event.stopPropagation()
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden")
      this.updateAccessibility()
      this._bind()
    } else {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.updateAccessibility()
    this._unbind()
  }

  _bind() {
    this._onDoc = (e) => { if (!this.element.contains(e.target)) this.close() }
    this._onKey = (e) => {
      if (e.key === "Escape") {
        this.close()
        if (this.hasTriggerTarget) this.triggerTarget.focus({ preventScroll: true })
      }
    }
    document.addEventListener("click", this._onDoc)
    document.addEventListener("keydown", this._onKey)
  }

  _unbind() {
    if (this._onDoc) document.removeEventListener("click", this._onDoc)
    if (this._onKey) document.removeEventListener("keydown", this._onKey)
  }

  disconnect() {
    this._unbind()
  }

  updateAccessibility() {
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", String(!this.menuTarget.classList.contains("hidden")))
  }
}
